import React from 'react';
import './Marquee.css';

// ✏️ PLACEHOLDER: Update the scrolling text to your slogan
const MARQUEE_TEXT = 'I always try to put my best service to my client . ';

export default function Marquee() {
  const repeated = Array(8).fill(MARQUEE_TEXT).join(' ');
  return (
    <div className="marquee-wrap" aria-hidden="true">
      <div className="marquee-track">
        <span>{repeated}</span>
        <span aria-hidden="true">{repeated}</span>
      </div>
    </div>
  );
}
